// extracted by mini-css-extract-plugin
export default {"faq-wrap":"WHU88","faq-title":"cW1PK","faq-collapse":"PzmUu","faqAnswer":"VPSgK"};